import axios from "axios";
import { restErrorHandler } from "../../helpers/restErrorHandler";
import { RestApiState } from "./Organization";
import { getCsrftoken } from '../../helpers/csfrToken';


export const AxiosRestorePassword = (email: string, setter: (value: RestApiState) => void) => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
        },
        withCredentials: true        
    }
    axios.post<any>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/auth/password/reset`, { email: email }, headers)
        .then(response => {

            if (response.status === 200) {
                setter(RestApiState.Success)
            }
        })
        .catch(error => {
            setter(RestApiState.Success)
        });
}


type AxiosConfirmPasswordProps ={
        uid: string;
        token: string;
        new_password: string;
        confirm_password: string;
}

       
export const AxiosConfirmPassword = ( 
    data: AxiosConfirmPasswordProps, 
    setter: (value: RestApiState) => void, 
    setError: (value: string) => void
) => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
        },
        withCredentials: true        
    }
    axios.post<any>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/auth/password/confirm`, data, headers)
        .then(response => {

            if (response.status === 200) {
                setter(RestApiState.Success)
            }
        })
        .catch(error => {
            if (error.response.data[0] === 'Invalid or expired token') {
                setError("Ссылка больше не работает")
            }
            setter(RestApiState.Restricted)
        });
}


type AxiosValidateUrlProps ={
    uid: string;
    token: string;
}


export const AxiosValidateUrl = ( 
    data: AxiosValidateUrlProps, 
    setter: (value: RestApiState) => void, 
) => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
        },
        withCredentials: true        
    }
    axios.post<any>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/auth/validate-url`, data, headers)
        .then(response => {

            if (response.status === 200) {
                setter(RestApiState.Success)
            }
        })
        .catch(error => {
            setter(RestApiState.BadRequest)
        });
}


interface AccountProps {
    full_name: string;
    position: string;
    company: string;
    phone: string;
    email: string;
    serials: string;
    comment: string;
}


export const AxiosNewAccount = (data: AccountProps, setter: (value: RestApiState) => void) => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
        },
        withCredentials: true        
    }
    axios.post<any>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/auth/account-request`, data, headers)
        .then(response => {
            if (response.status === 201) {
                setter(RestApiState.Success)
            }
        })
        .catch(error => {
            setter(RestApiState.BadRequest)
        });
}